
import cx from 'classnames';

import { PropsOf, AnyElement } from '@/utils/types';

// TS
type TextProps<T extends AnyElement> = PropsOf<T> & {
  as?: T;
  children?: React.ReactNode;
  kind?: 'blue' | 'gray' | 'lightGray' | 'indigo' | 'lightBlue' | 'white';
  className?: string;
  size?: 'xxs' | 'xs' | 'sm' | 'base' | 'lg' | 'xl' | '2xl' | '3xl' | '4xl';
};

// Class helpers
const sizeClass = {
  xxs: 'text-xxs',
  xs: 'text-xs',
  sm: 'text-sm',
  base: 'text-base',
  lg: 'text-lg',
  xl: 'text-xl',
  '2xl': 'text-2xl',
  '3xl': 'text-3xl',
  '4xl': 'text-4xl',
  '5xl': 'text-5xl',
} as const;

// Text
const Text = <T extends AnyElement>({
  as: Tag,
  children,
  kind,
  className,
  size,
  ...rest
}: TextProps<T>) => {
  const TextTag = (Tag || 'p') as React.ElementType;
  const classNames = cx(className, {
    'text-tim-primary': kind === 'blue',
    'text-tim-indigo': kind === 'indigo',
    'text-tim-secondary': kind === 'lightBlue',
    'text-gray-700': kind === 'gray',
    'text-gray-500': kind === 'lightGray',
    'text-white': kind === 'white',
    [sizeClass[size as never]]: size,
  });

  return (
    <TextTag className={classNames} {...rest}>
      {children}
    </TextTag>
  );
};

export default Text;
